import type { CategoriaDepartamento } from "../types";
import { DEPARTMENT_ZONES } from "./departmentZones";

export const _getDepartamentoInfo = (
  depto: string,
  categories: CategoriaDepartamento[]
): { categoria: CategoriaDepartamento; zona: string } | null => {
  const categoria = categories.find((cat) => cat.departamentos.includes(depto));
  if (!categoria) return null;

  const preciosIndividuales = categoria.precios_individuales?.[depto];

  // La capacidad es de cada departamento (el 4 es mediano y es para 2,
  // el 22 es grande y es para 5); la del grupo queda solo como respaldo.
  let capacidadReal = preciosIndividuales?.capacidad ?? categoria.capacidad;
  if (!preciosIndividuales?.capacidad) {
    if (categoria.nombre === "Departamentos Grandes") {
      capacidadReal = depto === "19" ? 6 : 4;
    } else if (categoria.nombre === "Departamentos Medianos") {
      capacidadReal = 3;
    } else if (categoria.nombre === "Departamentos Chicos") {
      capacidadReal = 2;
    }
  }

  return {
    categoria: {
      ...categoria,
      capacidad: capacidadReal,
      precioCorto: preciosIndividuales?.precioCorto ?? categoria.precioCorto,
      precioLargo: preciosIndividuales?.precioLargo ?? categoria.precioLargo,
    },
    zona:
      DEPARTMENT_ZONES.find((z) => z.departamentos.includes(depto))?.nombre ??
      "",
  };
};
